import { Control, Controller, RegisterOptions } from "react-hook-form";
import { ColourPicker } from "./ColourPicker";
import { ColourSurface, ColourTokenId } from "@/utils/colourTokens";

interface ColourPickerFieldProps {
  control: Control<any>;
  name: string;
  surface: ColourSurface;
  // The current value of the sibling name field, so swatches show live
  // initials. The owning form watches it and passes it down (field
  // components must not read form state themselves).
  initialsSource?: string;
  label?: string;
  disabled?: boolean;
  rules?: RegisterOptions;
}

export const ColourPickerField = ({
  control,
  name,
  surface,
  initialsSource,
  label,
  disabled,
  rules,
}: ColourPickerFieldProps) => (
  <Controller
    control={control}
    name={name}
    rules={rules}
    render={({ field: { value, onChange } }) => (
      <ColourPicker
        surface={surface}
        value={value as ColourTokenId | undefined}
        onChange={onChange}
        initialsSource={initialsSource}
        label={label}
        name={name}
        disabled={disabled}
      />
    )}
  />
);
